import { BROACAST_TEMPLATES_SELECT_TAB } from '../../Types';

export default tab => {
  return dispatch => {
    const action = {
      type: BROACAST_TEMPLATES_SELECT_TAB,
      payload: tab
    };
    dispatch(action);
  };
};
